import {pageModel, utils} from '@wallaby-ui/core';
import {find, first, isEmpty} from 'lodash';

import {Case} from 'src/js/model/case';
import {File} from 'src/js/model/file';

const RESULT_RESPONSE_CONTENT = 'content';

const RESULT_RESPONSE_FILES = 'files';
const RESULT_RESPONSE_CASES = 'cases';

const StaticResultItemModels = {
  [RESULT_RESPONSE_FILES]: File,
  [RESULT_RESPONSE_CASES]: Case,
};

class DynamicResultItem {
  constructor(resultItemModel, opts, dynamicResultItemsModels = {}) {
    const resultItemModels = {
      ...dynamicResultItemsModels,
      ...StaticResultItemModels,
    };
    return new resultItemModels[resultItemModel](opts);
  }
}

export class SearchResult {
  static determineServiceUrls(caseType, serviceUrls) {
    let newServiceUrls;
    if (isEmpty(caseType) || !serviceUrls.cases) {
      // reset services
      newServiceUrls = {...serviceUrls};
    } else {
      newServiceUrls = {...serviceUrls, ...serviceUrls.cases};
    }
    return newServiceUrls;
  }

  static initResultItems(
    rawDataFiles,
    resultItemModel,
    dynamicResultItemsModels = {}
  ) {
    const resultDocuments = [];
    if (rawDataFiles) {
      rawDataFiles.forEach((file) => {
        resultDocuments.push(
          new DynamicResultItem(resultItemModel, file, dynamicResultItemsModels)
        );
      });
    }
    return resultDocuments;
  }

  constructor(
    rawData = {},
    resultItemModel = RESULT_RESPONSE_FILES,
    dynamicResultItemsModels = {}
  ) {
    this.rawData = {...rawData};
    this.resultItems = [];
    if (this.rawData[RESULT_RESPONSE_CONTENT]) {
      this.resultItems = SearchResult.initResultItems(
        this.rawData[RESULT_RESPONSE_CONTENT],
        resultItemModel,
        dynamicResultItemsModels
      );
    }
    this.timestamp = this.rawData.timestamp;
    this.pagination = new pageModel.Page(this.rawData);
  }

  getResultItems() {
    return this.resultItems;
  }

  getResultItemsRaw() {
    const resultItemsRaw = [];
    if (this.resultItems) {
      this.resultItems.forEach((item) => {
        resultItemsRaw.push(item.rawData);
      });
    }
    return resultItemsRaw;
  }

  getTimestamp() {
    return this.timestamp;
  }

  getResultFile(docId) {
    return find(this.getResultItems(), (doc) =>
      utils.StringUtils.isEqualNumber(doc.getId(), docId)
    );
  }

  getFirstResultFile() {
    return first(this.getResultItems());
  }

  getPagination() {
    return this.pagination;
  }

  getCountInPage() {
    return this.getResultItems().length || 0;
  }
}

export class FilesResult extends SearchResult {
  constructor(rawData = {}) {
    super(rawData, RESULT_RESPONSE_FILES);
  }
}

export class CasesResult extends SearchResult {
  constructor(rawData = {}) {
    super(rawData, RESULT_RESPONSE_CASES);
  }
}

export default {DynamicResultItem, SearchResult, FilesResult, CasesResult};
